var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-popup',{attrs:{"title":"Crear grupo","active":_vm.popupActive},on:{"update:active":function($event){_vm.popupActive=$event}}},[_c('CreateGroup',{model:{value:(_vm.group),callback:function ($$v) {_vm.group=$$v},expression:"group"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }